var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "q-px-sm q-px-lg-lg",
      on: {
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.goToLogSearch.apply(null, arguments)
        }
      }
    },
    [
      _vm.showWatchlistTitle
        ? _c("div", { staticClass: "row q-col-gutter-md" }, [
            _c("div", { staticClass: "col" }, [
              _c("h4", { staticClass: "q-pt-md" }, [
                _vm._v(_vm._s(_vm.displayedWatchlist.name))
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row q-col-gutter-sm justify-between" }, [
        _c(
          "div",
          { staticClass: "col-3 col-md-2" },
          [
            _c("q-select", {
              attrs: {
                label: _vm.$t("product"),
                options: _vm.woodtypeOptions,
                "map-options": "",
                "emit-value": ""
              },
              model: {
                value: _vm.woodtype,
                callback: function($$v) {
                  _vm.woodtype = $$v
                },
                expression: "woodtype"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-5 col-sm-7 col-md-3 col-lg-4" },
          [
            _c("species-selector", {
              attrs: { error: _vm.insufficientSearchParams },
              model: {
                value: _vm.species,
                callback: function($$v) {
                  _vm.species = $$v
                },
                expression: "species"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 gt-sm" },
          [
            _c("q-input", {
              attrs: {
                type: "text",
                label: _vm.$t("logNo"),
                error: _vm.insufficientSearchParams
              },
              model: {
                value: _vm.logNo,
                callback: function($$v) {
                  _vm.logNo = $$v
                },
                expression: "logNo"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 gt-sm" },
          [
            _c("q-input", {
              attrs: {
                type: "text",
                label: _vm.$t("palletNo"),
                error: _vm.insufficientSearchParams
              },
              model: {
                value: _vm.palletNo,
                callback: function($$v) {
                  _vm.palletNo = $$v
                },
                expression: "palletNo"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-4 col-sm-2" }, [
          _c("div", { staticClass: "row text-right" }, [
            _c(
              "div",
              { staticClass: "col q-mt-md gt-sm" },
              [
                _c(
                  "q-btn",
                  {
                    staticClass: "cursor-pointer",
                    attrs: {
                      color: "primary",
                      icon: "undo",
                      size: "md",
                      dense: "",
                      flat: "",
                      round: ""
                    },
                    on: { click: _vm.resetSearchParams }
                  },
                  [
                    _c(
                      "q-badge",
                      { attrs: { color: "primary", floating: "" } },
                      [_vm._v(_vm._s(_vm.setFilterCount))]
                    ),
                    _vm._v(" "),
                    _c(
                      "q-tooltip",
                      { attrs: { "content-class": "bg-secondary" } },
                      [_vm._v(_vm._s(_vm.$t("tooltip.resetSearchParams")))]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.editSearchParams
              ? _c(
                  "div",
                  { staticClass: "col q-mt-md gt-sm" },
                  [
                    _c(
                      "q-btn",
                      {
                        attrs: {
                          color: "primary",
                          icon: "save",
                          loading: _vm.updatingWatchlist,
                          size: "md",
                          dense: "",
                          flat: "",
                          round: ""
                        },
                        on: { click: _vm.updateWatchlist }
                      },
                      [
                        _c(
                          "q-tooltip",
                          { attrs: { "content-class": "bg-secondary" } },
                          [_vm._v(_vm._s(_vm.$t("button.save")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.editSearchParams
              ? _c(
                  "div",
                  { staticClass: "col q-mt-md gt-sm" },
                  [
                    _c(
                      "q-btn",
                      {
                        staticClass: "cursor-pointer",
                        attrs: {
                          color: "primary",
                          disable: !_vm.sufficientSearchParamsGiven,
                          icon: "star_border",
                          size: "md",
                          dense: "",
                          flat: "",
                          round: ""
                        },
                        on: { click: _vm.createWatchlistFromSearchParams }
                      },
                      [
                        _c(
                          "q-tooltip",
                          { attrs: { "content-class": "bg-secondary" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "tooltip.createWatchlistFromSearchParams"
                                )
                              )
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col q-mt-md" },
              [
                _vm.displayAdvancedSearch === false
                  ? _c("q-btn", {
                      staticClass: "cursor-pointer",
                      attrs: {
                        color: "primary",
                        icon: "add",
                        size: "md",
                        dense: "",
                        flat: "",
                        round: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.setDisplayAdvancedSearch(true)
                        }
                      }
                    })
                  : _c("q-btn", {
                      staticClass: "cursor-pointer",
                      attrs: {
                        color: "primary",
                        icon: "remove",
                        size: "md",
                        dense: "",
                        flat: "",
                        round: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.setDisplayAdvancedSearch(false)
                        }
                      }
                    })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 col-md-4 q-mt-sm" },
              [
                !_vm.editSearchParams
                  ? _c(
                      "q-btn",
                      {
                        staticClass: "cursor-pointer",
                        attrs: {
                          color: "primary",
                          icon: "search",
                          loading: _vm.loadingLogs,
                          size: "md",
                          round: ""
                        },
                        on: { click: _vm.goToLogSearch }
                      },
                      [
                        _c(
                          "q-tooltip",
                          { attrs: { "content-class": "bg-secondary" } },
                          [_vm._v(_vm._s(_vm.$t("button.search")))]
                        )
                      ],
                      1
                    )
                  : _c(
                      "q-btn",
                      {
                        staticClass: "cursor-pointer",
                        attrs: {
                          color: "primary",
                          icon: "search",
                          loading: _vm.loadingLogs,
                          size: "md",
                          round: ""
                        },
                        on: { click: _vm.loadWatchlistPreview }
                      },
                      [
                        _c(
                          "q-tooltip",
                          { attrs: { "content-class": "bg-secondary" } },
                          [_vm._v(_vm._s(_vm.$t("button.preview")))]
                        )
                      ],
                      1
                    )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("q-slide-transition", [
        _vm.displayAdvancedSearch
          ? _c(
              "div",
              { staticClass: "q-pb-sm", attrs: { id: "advanced-search" } },
              [
                _c("div", { staticClass: "row q-col-gutter-sm lt-md" }, [
                  _c(
                    "div",
                    { staticClass: "col-4 col-sm-5" },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "text",
                          label: _vm.$t("logNo"),
                          error: _vm.insufficientSearchParams
                        },
                        model: {
                          value: _vm.logNo,
                          callback: function($$v) {
                            _vm.logNo = $$v
                          },
                          expression: "logNo"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-4 col-sm-5" },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "text",
                          label: _vm.$t("palletNo"),
                          error: _vm.insufficientSearchParams
                        },
                        model: {
                          value: _vm.palletNo,
                          callback: function($$v) {
                            _vm.palletNo = $$v
                          },
                          expression: "palletNo"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-4 col-sm-2" }, [
                    _c("div", { staticClass: "row text-right" }, [
                      _c(
                        "div",
                        { staticClass: "col q-mt-sm" },
                        [
                          _c(
                            "q-btn",
                            {
                              staticClass: "cursor-pointer",
                              attrs: {
                                color: "primary",
                                icon: "undo",
                                size: "md",
                                dense: "",
                                flat: "",
                                round: ""
                              },
                              on: { click: _vm.resetSearchParams }
                            },
                            [
                              _c(
                                "q-badge",
                                { attrs: { color: "primary", floating: "" } },
                                [_vm._v(_vm._s(_vm.setFilterCount))]
                              ),
                              _vm._v(" "),
                              _c(
                                "q-tooltip",
                                { attrs: { "content-class": "bg-secondary" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("tooltip.resetSearchParams"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.editSearchParams
                        ? _c(
                            "div",
                            { staticClass: "col q-mt-sm" },
                            [
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    disable: !_vm.sufficientSearchParamsGiven,
                                    icon: "star_border",
                                    size: "md",
                                    dense: "",
                                    flat: "",
                                    round: ""
                                  },
                                  on: {
                                    click: _vm.createWatchlistFromSearchParams
                                  }
                                },
                                [
                                  _c(
                                    "q-tooltip",
                                    {
                                      attrs: { "content-class": "bg-secondary" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "tooltip.createWatchlistFromSearchParams"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.editSearchParams
                        ? _c(
                            "div",
                            { staticClass: "col q-mt-sm" },
                            [
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    icon: "save",
                                    loading: _vm.updatingWatchlist,
                                    size: "md",
                                    dense: "",
                                    flat: "",
                                    round: ""
                                  },
                                  on: { click: _vm.updateWatchlist }
                                },
                                [
                                  _c(
                                    "q-tooltip",
                                    {
                                      attrs: { "content-class": "bg-secondary" }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("button.save")))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row q-col-gutter-sm" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-6 col-md-3 col-lg-2" },
                    [
                      _c("q-select", {
                        attrs: {
                          label: _vm.$t("label.qualities"),
                          options: _vm.filterData.qualities,
                          "option-value": "intCustomerQualityId",
                          "option-label": "strCustomerQualityName",
                          disable: !_vm.filterData.qualities.length,
                          loading: _vm.loadingLogFilters,
                          multiple: "",
                          "use-chips": "",
                          "map-options": "",
                          "emit-value": "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.qualities,
                          callback: function($$v) {
                            _vm.qualities = $$v
                          },
                          expression: "qualities"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-6 col-md-3 col-lg-2" },
                    [
                      _c("q-select", {
                        attrs: {
                          label: _vm.$t("label.structure"),
                          options: _vm.filterData.structures,
                          "option-value": "intStructureId",
                          "option-label": "strStructureName",
                          disable: !_vm.filterData.structures.length,
                          loading: _vm.loadingLogFilters,
                          "map-options": "",
                          "emit-value": "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.structure,
                          callback: function($$v) {
                            _vm.structure = $$v
                          },
                          expression: "structure"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-6 col-md-3 col-lg-2" },
                    [
                      _c("q-select", {
                        attrs: {
                          label: _vm.$t("label.thickness"),
                          options: _vm.filterData.thicknesses,
                          disable: !_vm.filterData.thicknesses.length,
                          loading: _vm.loadingLogFilters,
                          clearable: ""
                        },
                        model: {
                          value: _vm.thickness,
                          callback: function($$v) {
                            _vm.thickness = $$v
                          },
                          expression: "thickness"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-6 col-md-3 col-lg-2" },
                    [
                      _c("q-select", {
                        attrs: {
                          label: _vm.$t("label.characteristic"),
                          options: _vm.filterData.characteristics,
                          "option-value": "intCharacteristicId",
                          "option-label": "strCharacteristicName",
                          disable: !_vm.filterData.characteristics.length,
                          loading: _vm.loadingLogFilters,
                          "map-options": "",
                          "emit-value": "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.characteristic,
                          callback: function($$v) {
                            _vm.characteristic = $$v
                          },
                          expression: "characteristic"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-6 col-md-3 col-lg-4" },
                    [
                      _c("q-input", {
                        attrs: { label: _vm.$t("label.internalQuality") },
                        model: {
                          value: _vm.internalQuality,
                          callback: function($$v) {
                            _vm.internalQuality = $$v
                          },
                          expression: "internalQuality"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-6 col-md-3 col-lg-2" },
                    [
                      _c("div", { staticClass: "row q-col-gutter-sm" }, [
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("q-input", {
                              attrs: {
                                label:
                                  _vm.$t("label.length") +
                                  " " +
                                  _vm.$t("label.from"),
                                suffix: _vm.$t("unit.cm")
                              },
                              model: {
                                value: _vm.lengthFrom,
                                callback: function($$v) {
                                  _vm.lengthFrom = $$v
                                },
                                expression: "lengthFrom"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("q-input", {
                              attrs: {
                                label:
                                  _vm.$t("label.length") +
                                  " " +
                                  _vm.$t("label.to"),
                                suffix: _vm.$t("unit.cm")
                              },
                              model: {
                                value: _vm.lengthMax,
                                callback: function($$v) {
                                  _vm.lengthMax = $$v
                                },
                                expression: "lengthMax"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-6 col-md-3 col-lg-2" },
                    [
                      _c("div", { staticClass: "row q-col-gutter-sm" }, [
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("q-input", {
                              attrs: {
                                label:
                                  _vm.$t("label.width") +
                                  " " +
                                  _vm.$t("label.from"),
                                suffix: _vm.$t("unit.cm")
                              },
                              model: {
                                value: _vm.widthFrom,
                                callback: function($$v) {
                                  _vm.widthFrom = $$v
                                },
                                expression: "widthFrom"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("q-input", {
                              attrs: {
                                label:
                                  _vm.$t("label.width") +
                                  " " +
                                  _vm.$t("label.to"),
                                suffix: _vm.$t("unit.cm")
                              },
                              model: {
                                value: _vm.widthTo,
                                callback: function($$v) {
                                  _vm.widthTo = $$v
                                },
                                expression: "widthTo"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-6 col-md-3 col-lg-2" },
                    [
                      _c("div", { staticClass: "row q-col-gutter-sm" }, [
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("q-input", {
                              attrs: {
                                label:
                                  _vm.$t("label.grade") +
                                  " " +
                                  _vm.$t("label.from")
                              },
                              model: {
                                value: _vm.gradeFrom,
                                callback: function($$v) {
                                  _vm.gradeFrom = $$v
                                },
                                expression: "gradeFrom"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("q-input", {
                              attrs: {
                                label:
                                  _vm.$t("label.grade") +
                                  " " +
                                  _vm.$t("label.to")
                              },
                              model: {
                                value: _vm.gradeTo,
                                callback: function($$v) {
                                  _vm.gradeTo = $$v
                                },
                                expression: "gradeTo"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-6 col-md-3 col-lg-2" },
                    [
                      _c("q-input", {
                        attrs: { label: _vm.$t("label.info") },
                        model: {
                          value: _vm.info,
                          callback: function($$v) {
                            _vm.info = $$v
                          },
                          expression: "info"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }